// designData.js

export const designSectionData = {
  en: {
    dashboard: {
      main: "/assets/images/dashboard-en.png",
    },

    requests: {
      main: "/assets/images/requests-en.png",
    },

    attendance: {
      main: "/assets/images/attendance-en.png",
    },

    salaries: {
      main: "/assets/images/salaries-en.png",
    },

    meetings: {
      main: "/assets/images/meetings-en.png",
    },

    applicants: {
      main: "/assets/images/applicants-en.png",
    },
  },

  ar: {
    dashboard: {
      main: "/assets/images/dashboard-ar.png",
    },

    requests: {
      main: "/assets/images/requests-ar.png",
    },

    attendance: {
      main: "/assets/images/attendance-ar.png",
    },

    salaries: {
      main: "/assets/images/salaries-ar.png",
    },

    meetings: {
      main: "/assets/images/meetings-ar.png",
    },

    applicants: {
      main: "/assets/images/applicants-ar.png",
    },
  },
};